jQuery(document).ready(function($){
  $(document).on('click','.steps-container .step',function(){

    $('.steps-container .step').removeClass('active');
    $(this).addClass('active');
    
    var step = $(this).attr('data-step');
    // $('.step-tab-content').removeClass('active');
    // $('.step-tab-content[data-tab-content="' + step + '"]').addClass('active');

    $('.step-tab-content').hide();
    $('.step-tab-content[data-tab-content="' + step + '"]').css({
      display: 'flex',
      opacity: 0
    }).animate({ opacity: 1 }, 900);
    
  });

  const swiperxxx = new Swiper('#castle-you-slider', {
    slidesPerView: 1.3, // Default for desktop
    spaceBetween: 10,
    loop: true,
    autoplay: {
      delay: 3000, // Time between slides in milliseconds (3 seconds)
      disableOnInteraction: false, // Keeps autoplay running even after user interaction
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      // Tablet view (example: up to 1024px width)
      1024: {
        slidesPerView: 4.2,
      },
      // Mobile view (example: up to 768px width)
      768: {
        slidesPerView: 1.3,
      },
    },
  });



  const faqItems = document.querySelectorAll('.faq-container .faq-item');

  // Add 'faq-item-active' to the first item by default
  if (faqItems.length > 0) {
    faqItems[0].classList.add('faq-item-active');
  }

  // Toggle 'faq-item-active' class on click
  faqItems.forEach(function(item) {
    item.addEventListener('click', function() {
      this.classList.toggle('faq-item-active');
    });
  });
  
});